import React from "react";
import { MdClose } from "react-icons/md";

import ContainedButton from "components/layout/form/containedButton";

import { Container, ContainerButtons, ModalHeader, ModalStyle } from "./styles";

interface IDebitFailModal {
  openModal: boolean;
  modalFunction: React.Dispatch<React.SetStateAction<boolean>>;
  text?: string;
}

const DebitFailModal = ({
  openModal,
  modalFunction,
  text = "É necessário aguardar que a última solicitação seja finalizada. O prazo é de 2 dias úteis para novas solicitações.",
}: IDebitFailModal): JSX.Element => {
  return (
    <ModalStyle
      show={openModal}
      animation={false}
      centered
      onHide={() => modalFunction(false)}
    >
      <ModalHeader>
        <span>Débito automático</span>
        <MdClose size={24} onClick={() => modalFunction(false)} />
      </ModalHeader>
      <Container>
        <span>
          Não foi possível completar a solicitação.
          <br />
          {text}
        </span>
        <ContainerButtons>
          <ContainedButton block onClick={() => modalFunction(false)}>
            Ok
          </ContainedButton>
        </ContainerButtons>
      </Container>
    </ModalStyle>
  );
};

export default DebitFailModal;
